import { heatmapLayout } from '@/lib/zambepong-stats'

type CupHeatmapProps = { heatmap: number[]; cupCount: 3 | 6 }

const CUP_RADIUS = 16
const CUP_GAP = 12
const ROW_GAP = 14
const CUP_STEP = CUP_RADIUS * 2 + CUP_GAP
const ROW_STEP = CUP_RADIUS * 2 + ROW_GAP

/** Triangolo dei bicchieri (base in alto, punta in basso): opacità del pallino `sea` proporzionale ai
 * colpi rispetto al massimo della griglia; i bicchieri mai colpiti restano un contorno tratteggiato. */
export function CupHeatmap({ heatmap, cupCount }: CupHeatmapProps) {
  const layout = heatmapLayout(cupCount)
  const maxHits = Math.max(...heatmap, 1)
  const maxRowLength = Math.max(...layout.map((row) => row.length))
  const width = maxRowLength * CUP_STEP - CUP_GAP
  const height = layout.length * ROW_STEP - ROW_GAP

  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} aria-hidden="true">
      {layout.map((row, rowIndex) => {
        const rowWidth = row.length * CUP_STEP - CUP_GAP
        const rowStartX = (width - rowWidth) / 2
        const cy = rowIndex * ROW_STEP + CUP_RADIUS
        return row.map((cupIndex, columnIndex) => {
          const hits = heatmap[cupIndex] ?? 0
          const cx = rowStartX + columnIndex * CUP_STEP + CUP_RADIUS
          const intensity = hits > 0 ? 0.25 + (hits / maxHits) * 0.75 : 0
          return (
            <g key={cupIndex}>
              <circle
                cx={cx}
                cy={cy}
                r={CUP_RADIUS}
                className={hits > 0 ? 'fill-sea' : 'fill-paper stroke-line'}
                style={hits > 0 ? { opacity: intensity } : undefined}
                strokeWidth={hits > 0 ? 0 : 1.5}
                strokeDasharray={hits > 0 ? undefined : '3 3'}
              />
              {hits > 0 && (
                <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central" className="fill-paper font-body text-[10px] font-bold">
                  {hits}
                </text>
              )}
            </g>
          )
        })
      })}
    </svg>
  )
}
